import { AutogenModelDistanceType, AutogenRowDistanceType } from "./autogen/AutogenModelDistanceType";

export class ModelDistanceType extends AutogenModelDistanceType<RowDistanceType> {
	constructor() {
		super(RowDistanceType);
	}
}

export class RowDistanceType extends AutogenRowDistanceType {
}